import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ArrowRightIcon } from 'lucide-react';
export function HLCombineBBL() {
  return <section className="bg-[#FF1493] py-[60px] lg:py-[100px]" data-id="element-1364">
      <div className="max-w-[900px] mx-auto px-6 lg:px-8" data-id="element-1365">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1366">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-8 font-[600] font-[Poppins,_sans-serif]" data-id="element-1367">
            COMBINE WITH BBL TREATMENT
          </h2>

          <p className="text-white text-[17px] leading-[1.7] font-body mb-10" data-id="element-1368">
            Together with a BBL Forever Young, you can enhance the results of
            your Halo skin resurfacing and say goodbye to dull, damaged skin.
            Forever Young is a cutting-edge photorejuvenation treatment that
            utilizes BroadBand Light (BBL) technology to address various signs
            of aging and sun damage. This treatment stimulates the production of
            collagen and elastin in the skin, resulting in improved skin
            texture, reduced fine lines and wrinkles, and a more youthful
            appearance.
          </p>

          <a href="/bbl" className="bg-white px-12 py-6 shadow-lg inline-flex items-center gap-4 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 mb-10 group" data-id="element-1369">
            <span className="text-black text-[22px] font-bold font-[Poppins,_sans-serif]" data-id="element-1370">
              BBL
            </span>
            <ArrowRightIcon size={20} className="text-[#FF1493] group-hover:translate-x-1 transition-transform duration-300" data-id="element-1371" />
          </a>

          <p className="font-serif italic text-white text-2xl lg:text-[28px]" data-id="element-1372">
            Treat yourself!
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}